import { globals, site, anodum, hdrm, template } from '@yola/ws-sdk';
import { COOKIE_BANNER_TAG_NAME, COOKIE_BANNER_SETTING_ID } from '../constants';

const getCookieBannerData = (state) => {
  const cookieBannerVariable = template.selectors.getVariableValueByPath(state, 'cookieBanner[0]');
  const { globalId } = cookieBannerVariable || {};

  return { globalId };
};

const applyCookieBannerPresence = (store, isCookieBannerEnabled) => {
  const state = store.getState();
  const { globalId } = getCookieBannerData(state);
  const global = globals.selectors.getGlobal(state, globalId);

  if (!global || !global.html) return;

  const globalElement = anodum.parseElementFromString(global.html);
  const htmlBefore = globalElement.outerHTML;

  hdrm.helpers.updateChildrenPresence(
    globalElement,
    COOKIE_BANNER_TAG_NAME,
    isCookieBannerEnabled,
    COOKIE_BANNER_SETTING_ID
  );

  const htmlAfter = globalElement.outerHTML;

  if (htmlAfter !== htmlBefore) {
    store.dispatch(globals.actions.setGlobalHTML(globalId, htmlAfter));
  }
};

const setCookieBanner = (store) => (next) => (action) => {
  if (action.type === site.actionTypes.SET_ACTIVE_PAGE) {
    const settings = site.selectors.getSettings(store.getState());

    applyCookieBannerPresence(store, Boolean(settings?.isCookieBannerEnabled));
  }

  if (action.type === site.actionTypes.UPDATE_SETTINGS) {
    const { settings } = action.payload;

    if (settings && 'isCookieBannerEnabled' in settings) {
      applyCookieBannerPresence(store, Boolean(settings.isCookieBannerEnabled));
    }
  }

  next(action);
};

export default setCookieBanner;
